import { useNavigate } from '@tanstack/react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { markAsRead, type Notification } from '@/api/notifications'

export function useNotificationRedirect() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const markReadMutation = useMutation({
    mutationFn: markAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
  })

  const handleNotificationClick = (
    e: React.MouseEvent,
    notification: Notification,
    setOpen: (open: boolean) => void
  ) => {
    e.preventDefault()
    e.stopPropagation()

    // Mark as read immediately
    if (!notification.is_read) {
      markReadMutation.mutate(notification.id)
    }

    // Close popover
    setOpen(false)


    const type = notification.notification_type || (notification as any).data?.notification_type
    const id = notification.related_object_id || (notification as any).data?.related_object_id

    console.log(`Handling notification click: type=${type}, id=${id}`)

    // Handle redirection based on type
    switch (type) {
      // 📅 Appointment Related
      case 'UPCOMING':
      case 'RESCHEDULED':
      case 'CANCELLED':
      case 'APPOINTMENT':
        if (id) {
          // Note: Route /appointments/$id is expected to exist or be created
          // navigate({ to: `/appointments/${id}` })
          navigate({ to: '/dashboard' })
        } else {
          // Fallback to list if no ID
           // navigate({ to: '/appointments' })
           navigate({ to: '/dashboard' })
        }
        break
      
      // ⚖️ Case Related
      case 'MAHAKIM_UPDATE':
      case 'CASE_RELATION': 
        if (id) {
           navigate({ to: `/cases/${id}` })
        } else {
           navigate({ to: '/cases' })
        }
        break
        
      case 'PREPARE_CASE':
        if (id) {
           navigate({ to: `/cases/${id}`, search: { name: 'analysis' } })
        } else {
           navigate({ to: '/cases' })
        }
        break
      
      // 📄 Template Requests
      case 'TEMPLATE_REQUEST':
          // Redirect to the admin template requests page
          // If we had a detail page: `/template-requests/${id}`
          navigate({ to: '/template-requests' })
        break
        
      // 📢 System / Default
      case 'SYSTEM':
      case 'ANNOUNCEMENT':
      default:
         // Default fallback logic
         // For 'ANNOUNCEMENT', we might want to let the existing modal handler deal with it if it's unrelated to navigation
         // But IF a user clicks it in the list, going to /notifications is a safe fallback
         navigate({ to: '/dashboard' })
        break
    }
  }

  return { handleNotificationClick }
}
